import {
  IndustrialRefrigeratorIcon,
  IndustrialWasherDryerIcon,
  IndustrialOvenRangeIcon,
  IndustrialDishwasherIcon,
  IndustrialMicrowaveIcon,
  IndustrialOtherAppliancesIcon,
} from "@/components/industrial-appliance-icons"

export const serviceData = [
  {
    title: "Refrigerator Repair",
    description:
      "Is your refrigerator not cooling properly, making strange noises, or leaking water? Our technicians can diagnose and repair all types of refrigerator issues, including:",
    features: [
      "Temperature control problems",
      "Ice maker repairs",
      "Water dispenser issues",
      "Compressor and condenser repairs",
      "Seal and gasket replacement",
      "Frost buildup problems",
    ],
    icon: IndustrialRefrigeratorIcon,
    image: "/images/services/refrigerator-repair.png",
    alt: "Refrigerator repair service",
  },
  {
    title: "Washer & Dryer Repair",
    description:
      "Having issues with your washing machine or dryer? Our technicians are experienced in repairing all types of washer and dryer problems, including:",
    features: [
      "Washing machine not spinning or draining",
      "Dryer not heating or taking too long to dry",
      "Unusual noises or vibrations",
      "Water leaks and drainage issues",
      "Door and latch problems",
      "Control board and timer repairs",
    ],
    icon: IndustrialWasherDryerIcon,
    image: "/images/services/washer-dryer-repair.png",
    alt: "Washer and dryer repair service",
  },
  {
    title: "Oven & Range Repair",
    description:
      "Is your oven not heating properly or your stovetop burners not working? Our technicians can fix all types of oven and range issues, including:",
    features: [
      "Oven not heating to the correct temperature",
      "Burners not igniting or heating properly",
      "Self-cleaning function issues",
      "Oven door problems",
      "Control panel and display malfunctions",
      "Gas line and ignition repairs",
    ],
    icon: IndustrialOvenRangeIcon,
    image: "/images/services/oven-range-repair.png",
    alt: "Oven and range repair service",
  },
  {
    title: "Dishwasher Repair",
    description:
      "Is your dishwasher not cleaning properly, leaking, or making unusual noises? Our technicians can diagnose and fix all types of dishwasher problems, including:",
    features: [
      "Poor cleaning performance",
      "Drainage and water flow issues",
      "Unusual noises during operation",
      "Leaking and water damage prevention",
      "Door latch and seal problems",
      "Control panel and electrical repairs",
    ],
    icon: IndustrialDishwasherIcon,
    image: "/images/services/dishwasher-repair.png",
    alt: "Dishwasher repair service",
  },
  {
    title: "Microwave Repair",
    description:
      "Is your microwave not heating properly or making unusual noises? Our technicians can diagnose and fix all types of microwave issues, including:",
    features: [
      "Heating problems and uneven cooking",
      "Turntable not rotating properly",
      "Control panel and display issues",
      "Door latch and safety switch repairs",
      "Unusual noises during operation",
      "Power issues and electrical repairs",
    ],
    icon: IndustrialMicrowaveIcon,
    image: "/images/services/microwave-repair.png",
    alt: "Microwave repair service",
  },
  {
    title: "Other Appliances",
    description:
      "We also repair a variety of other household appliances to keep your home running smoothly, including:",
    features: [
      "Garbage disposals installation and repair",
      "Ice machines and ice makers",
      "Wine coolers and beverage centers",
      "Range hoods and ventilation systems",
    ],
    icon: IndustrialOtherAppliancesIcon,
    image: "/images/services/other-appliances-v2.png",
    alt: "Other appliance repair services",
  },
]
